import { inject, Pipe, PipeTransform } from '@angular/core';
import { Planning } from '../classes/planning.class';
import { EntityType } from '../services/entities/entity-type.class';
import { EntityTypeService } from '../services/entity-type.service';

@Pipe({
    name: 'userCanEditPlanning',
    standalone: false,
})
export class UserCanEditPlanningPipe implements PipeTransform {
    private entityTypeService = inject(EntityTypeService);

    transform(planning: Planning, entityType: EntityType) {
        return this.entityTypeService.userCanEditPlanning(entityType, planning);
    }
}
